import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getIp = createAsyncThunk('ip/fetch', async () => {
  const ipData = await axios.get('https://api.ipify.org/?format=json');
  window.localStorage.setItem('ipAddress', ipData.data.ip);
  return ipData.data.ip;
});

export const thunks = {
  getIp,
};
